import {
  getRuntimeActionGrounding,
  type RuntimeActionGrounding,
} from "@cogo/action-registry"

export interface ResolvedRuntimeAction {
  requestedAction: string
  canonicalAction: string
  isAlias: boolean
  grounding: RuntimeActionGrounding
}

/** Resolves only actions backed by the canonical runtime grounding registry. */
export function resolveRuntimeAction(
  actionName: string,
): ResolvedRuntimeAction | undefined {
  const grounding = getRuntimeActionGrounding(actionName)
  if (!grounding) return undefined

  return {
    requestedAction: actionName,
    canonicalAction: grounding.action,
    isAlias: actionName !== grounding.action,
    grounding,
  }
}
